module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "plm_hd"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/CH_authors"
    }
  }, [_vm._v("About the authors")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/CH_preface"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/CH_notetoreader"
    }
  }, [_vm._v("A note to the reader")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1s"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/CH_seriesintro"
    }
  }, [_vm._v("Series introduction: the Contemporary Christian – the then and the now")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/CH_intro",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Church")]), _vm._v(": Introduction")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/CH_ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 Secular challenges to the church")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/CH_ch02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 Evangelism through the local church")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/CH_ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 Dimensions of church renewal")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/CH_ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 The church’s pastors")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/CH_conc",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion: the now and the not yet")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1s"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/CH_notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07e101e4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/CH_contents.vue
// module id = 69
// module chunks = 0